export default __webpack_public_path__ + "static/media/project2.af12fd06.webp";